const getOptions = (options, key) => 
/**
 * TODO: Make test for this
 * Always return a new object otherwise delay is overwritten by results of stagger
 * and this results in no stagger
 */
options[key] ? Object.assign(Object.assign({}, options), options[key]) : Object.assign({}, options);

export { getOptions };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@motionone/dom/dist/animate/utils/options.es.js
// module id = FtKP
// module chunks = 0